import { Injectable } from '@odinjs/odin';
import { AutocompleteAPI, FetchAPI } from '@philips-internal/oswald-ui-components';

import { ChartFilter } from '../interfaces';

export interface ChartFilterProps {
  autoCompleteYear?: AutocompleteAPI;
  valueYear?: string | null;
  autoCompleteMonth?: AutocompleteAPI;
  valueMonth?: number[] | null;
  autoCompleteContract?: AutocompleteAPI;
  autoCompleteClassification?: AutocompleteAPI;
  valueClassification?: string | null;
  autocompleteTimeCourse?: AutocompleteAPI;
  valueTimeCourse?: string | null;
  autocompleteApplication?: AutocompleteAPI;
  fetchs: FetchAPI[];
  onExecute?: (params: ChartFilter) => void;
}

@Injectable({})
export class ChartFilterService {

  static executeSearch(props: ChartFilterProps): void {
    const {
      autoCompleteYear, valueYear,
      autoCompleteMonth, valueMonth,
      autoCompleteClassification, valueClassification,
      autoCompleteContract,
      autocompleteTimeCourse, valueTimeCourse,
      fetchs,
      onExecute,
    } = props;
    const params: ChartFilter = {};

    if (autoCompleteYear) {
      const year = autoCompleteYear.getValue() as any;
      params.year = year.value as string;
    } else if (valueYear) {
      params.year = valueYear;
    }

    if (autoCompleteMonth) {
      const months = autoCompleteMonth.getValue() as any[];
      params.months = months.map(month => month.value as number);
    } else if (valueMonth) {
      params.months = valueMonth;
    }

    if (autoCompleteContract) {
      const contract = autoCompleteContract.getValue() as any[];
      if (contract && contract.length > 0 && contract[0]) {
        params.contract = contract[0].value as string;
      }
    }
    
    if (autoCompleteClassification) {
      const classification = autoCompleteClassification.getValue() as any;
      params.classification = classification.value as string;
    } else if (valueClassification) {
      params.classification = valueClassification;
    }
    
    if (autocompleteTimeCourse) {
      const period = autocompleteTimeCourse.getValue() as any;
      params.period = period.value as string;
    } else if (valueTimeCourse) {
      params.period = valueTimeCourse;
    }

    fetchs.forEach(fetch => {
      fetch.setParameters(params);
      fetch.forceFetch();
    });
    if (onExecute) {
      onExecute(params);
    }
  }
}
